if (!customElements.get('seolab-laptop-tabs')) {
  customElements.define('seolab-laptop-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, options);
    }

    select(index) {
      if (!this.tabs[index]) return;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
